var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.accessType !== "NoAccess"
        ? _c("proposalHistory", { attrs: { "access-type": _vm.accessType } })
        : _vm._e(),
      _vm.accessType == "NoAccess"
        ? _c("h1", [_vm._v("No tienes acceso a esta seccion")])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }